var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnsFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.04 2H5.99335C4.93425 2 3.9185 2.42143 3.1696 3.17158C2.4207 3.92172 2 4.93913 2 6V18C2 19.0609 2.4207 20.0783 3.1696 20.8284C3.9185 21.5786 4.93425 22 5.99335 22H18.04C19.0933 21.9912 20.1005 21.5659 20.8422 20.8167C21.5839 20.0675 22 19.0551 22 18V6C22 4.94488 21.5839 3.93249 20.8422 3.1833C20.1005 2.4341 19.0933 2.00879 18.04 2ZM15.2779 7.78001H14.0932C12.762 7.78001 13.0216 8.85334 13.0216 8.85334V10.2933H15.2779L14.9784 12.6267H13.0216V18.38H10.6523V12.6267H8.75544V10.2933H10.6523V8.29333C10.6523 4.82 15.3112 5.77333 15.3112 5.77333L15.2779 7.78001Z",
    fill: "#A3B1CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsFacebook);
export default __webpack_public_path__ + "static/media/sns-facebook.6dfbdec7a74f792da0b78a25825ff6af.svg";
export { ForwardRef as ReactComponent };